/**
 * @license
 * Copyright 2016 Google Inc.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
export var VolumeChunkEncoding;
(function (VolumeChunkEncoding) {
  VolumeChunkEncoding[VolumeChunkEncoding["RAW"] = 0] = "RAW";
  VolumeChunkEncoding[VolumeChunkEncoding["JPEG"] = 1] = "JPEG";
  VolumeChunkEncoding[VolumeChunkEncoding["COMPRESSED_SEGMENTATION"] = 2] = "COMPRESSED_SEGMENTATION";
})(VolumeChunkEncoding || (VolumeChunkEncoding = {}));
export class ChangeSpec {}
export class VolumeSourceParameters {}
VolumeSourceParameters.RPC_ID = 'brainmaps/VolumeChunkSource';
export class MultiscaleMeshSourceParameters {}
MultiscaleMeshSourceParameters.RPC_ID = 'brainmaps/MultiscaleMeshSource';
export class MeshSourceParameters {}
MeshSourceParameters.RPC_ID = 'brainmaps/MeshSource';
export class SkeletonSourceParameters {}
SkeletonSourceParameters.RPC_ID = 'brainmaps/SkeletonSource';
export class AnnotationSourceParameters {}
AnnotationSourceParameters.RPC_ID = 'brainmaps/Annotation';
export class AnnotationSpatialIndexSourceParameters {}
AnnotationSpatialIndexSourceParameters.RPC_ID = 'brainmaps/AnnotationSpatialIndex';
//# sourceMappingURL=base.js.map